import { SAMPLER_ALLOWED_PROMO_CODES } from '../experiments/constants';
import { DEFAULT_SAMPLER_ALLOWED_PROMO_CODES } from './constants';

export const normalizePromoCodeList = value => {
  if (Array.isArray(value)) {
    return value.filter(Boolean).map(String);
  }

  if (typeof value === 'string' && value.trim()) {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.filter(Boolean).map(String);
      }
    } catch {
      //* Flagship may store a comma-separated list instead of JSON. Should not be the case...but you never know.
    }

    return value
      .split(',')
      .map(code => code.trim())
      .filter(Boolean);
  }

  return DEFAULT_SAMPLER_ALLOWED_PROMO_CODES;
};

export const isSamplerAllowedPromoCode = (
  code,
  allowlist = DEFAULT_SAMPLER_ALLOWED_PROMO_CODES,
) => {
  if (!code) return false;

  const normalizedAllowlist = normalizePromoCodeList(allowlist);
  return normalizedAllowlist.some(
    allowed => allowed.toLowerCase() === String(code).toLowerCase(),
  );
};

export const isSamplerAllowlistReady = modifications =>
  Boolean(modifications?.has?.(SAMPLER_ALLOWED_PROMO_CODES));

//* null means the flag has not loaded. An empty array is loaded but unconfigured.
export const resolveSamplerAllowlist = (isReady, value) => {
  if (!isReady) return null;
  return normalizePromoCodeList(value);
};
